import React from 'react';

const TOOLS = [
  { id: 'iso', key: 'I', title: 'Iso' },
  { id: 'front', key: 'F', title: 'Front' },
  { id: 'side', key: 'S', title: 'Side' },
  { id: 'top', key: 'T', title: 'Top' },
  { id: 'walk', key: 'G', title: 'Walk' },
  { id: 'annotate', key: 'N', title: 'Annotate' },
  { id: 'shot', key: 'C', title: 'Screenshot' },
];

/**
 * Sim lab rail — presets · walk · annotate · capture.
 * Blueprint: docs/SIMULATION_LAB.md · docs/SIM_LAB_ANNOTATE.md
 */
export default function SimLabToolRail({
  activePreset = 'iso',
  onPreset,
  onCapture,
  capturing = false,
  walkMode = false,
  onToggleWalk,
  annotateMode = false,
  onToggleAnnotate,
}) {
  return (
    <div className="rail" role="toolbar" aria-label="Sim lab tools">
      {TOOLS.map((t) => {
        const isShot = t.id === 'shot';
        const isWalk = t.id === 'walk';
        const isAnn = t.id === 'annotate';
        const active = isAnn
          ? annotateMode
          : isWalk
            ? walkMode
            : !isShot && !walkMode && !annotateMode && activePreset === t.id;
        return (
          <button
            key={t.id}
            type="button"
            className={`rail-btn${active ? ' active' : ''}`}
            title={
              isShot
                ? capturing
                  ? 'Capturing…'
                  : `${t.title} (${t.key})`
                : isWalk
                  ? walkMode
                    ? 'Exit walk (G / Esc)'
                    : 'Walk · 6 ft POV (G)'
                  : isAnn
                    ? annotateMode
                      ? 'Exit annotate (N)'
                      : 'Annotate pins (N)'
                    : `${t.title} (${t.key})`
            }
            aria-pressed={isShot ? undefined : active}
            disabled={isShot && capturing}
            onClick={() => {
              if (isShot) onCapture?.();
              else if (isWalk) onToggleWalk?.();
              else if (isAnn) onToggleAnnotate?.();
              else onPreset?.(t.id);
            }}
          >
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11 }}>
              {isShot
                ? capturing
                  ? '…'
                  : '▣'
                : isWalk
                  ? 'W'
                  : isAnn
                    ? 'N'
                    : t.title.slice(0, 1)}
            </span>
            <span className="k">{t.key}</span>
          </button>
        );
      })}
    </div>
  );
}
